/* FrogFits extras — sticky mobile add-to-cart for product pages.
   Builds a fixed bottom bar that mirrors the real ATC button (same
   AJAX add via a proxied click), shown once the buy box scrolls away. */
(function () {
  function init() {
    var realSubmit = document.querySelector('.product-form__submit');
    var titleEl = document.querySelector('.product__title h1, .product__title');
    if (!realSubmit || !titleEl) return; // not a product page
    if (document.querySelector('.ff-sticky-atc')) return;

    var priceEl = document.querySelector(
      '.product .price__regular .price-item--regular, .product .price-item--sale, .product .price-item--regular'
    );

    var bar = document.createElement('div');
    bar.className = 'ff-sticky-atc';
    bar.innerHTML =
      '<div class="ff-sticky-atc__info">' +
      '<span class="ff-sticky-atc__title"></span>' +
      '<span class="ff-sticky-atc__price"></span>' +
      '</div>' +
      '<button type="button" class="ff-sticky-atc__btn"></button>';
    document.body.appendChild(bar);

    var btn = bar.querySelector('.ff-sticky-atc__btn');
    bar.querySelector('.ff-sticky-atc__title').textContent = titleEl.textContent.trim();

    function sync() {
      var priceNow = document.querySelector(
        '.product .price__regular .price-item--regular, .product .price-item--sale, .product .price-item--regular'
      );
      bar.querySelector('.ff-sticky-atc__price').textContent = priceNow
        ? priceNow.textContent.replace(/\s+/g, ' ').trim()
        : '';
      btn.textContent = realSubmit.querySelector('span')
        ? realSubmit.querySelector('span').textContent.trim()
        : 'Add to cart';
      btn.disabled = realSubmit.disabled || realSubmit.getAttribute('aria-disabled') === 'true';
    }
    sync();

    btn.addEventListener('click', function () {
      realSubmit.click();
    });

    // keep label/price in sync when variants change
    var observer = new MutationObserver(sync);
    observer.observe(realSubmit, { attributes: true, childList: true, subtree: true });
    var priceWrap = document.querySelector('.product .price');
    if (priceWrap) observer.observe(priceWrap, { childList: true, subtree: true, characterData: true });

    // show bar only after the real button scrolls out of view
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              bar.classList.remove('is-visible');
            } else if (e.boundingClientRect.top < 0) {
              bar.classList.add('is-visible');
            }
          });
        },
        { threshold: 0 }
      );
      io.observe(realSubmit);
    } else {
      bar.classList.add('is-visible');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* FrogFits — "Ask about my rack" links (href containing #ff-chat) open the
   store chat widget instead of navigating. Falls back to the contact page
   if the chat widget isn't on the page. */
(function () {
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest && e.target.closest('a[href*="#ff-chat"]');
    if (!a) return;
    e.preventDefault();
    var sc = document.querySelector('shopify-chat');
    var btn = sc && sc.shadowRoot && sc.shadowRoot.querySelector('button.activator');
    if (btn) {
      btn.click();
    } else {
      window.location.href = '/pages/contact';
    }
  });
})();

/* FrogFits — mockup-style option labels ("Accent color — Black"), swatch note,
   and per-pack pricing under pills ("$29.99 each"). Prices come from the
   product AJAX JSON; only shown on options where the price actually varies.
   Re-applies after Shopify section re-renders on variant change. */
(function () {
  var NAME_MAP = { 'Color': 'Accent color', 'Accent Color': 'Accent color', 'Size': 'Hardware size' };
  var PRODUCT_CACHE = {};

  // FrogFits-specific wording doesn't belong on other vendors' products
  // (e.g. GrytFit flooring, where "Size" is not rack hardware).
  function isOtherVendor() {
    var v = document.querySelector('.product__info-wrapper .product__text, .product__info-container .product__text');
    return !!(v && !/frogfits/i.test(v.textContent));
  }

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function unitCount(value) {
    var m = value.match(/(\d+)\s*[- ]?\s*(?:packs?|pcs?|pc)\b/i);
    if (m) return parseInt(m[1], 10);
    if (/\bsingle\b/i.test(value)) return 1;
    return null;
  }

  function productUrlFor(fs) {
    var host = fs.closest('product-info');
    if (host && host.dataset && host.dataset.url) {
      var u = host.dataset.url.split('?')[0];
      var m2 = u.match(/\/products\/[^\/?#]+/);
      if (m2) return m2[0];
    }
    var m = window.location.pathname.match(/\/products\/[^\/?#]+/);
    return m ? m[0] : null;
  }

  function getProduct(fs, cb) {
    var url = productUrlFor(fs);
    if (!url) return;
    if (PRODUCT_CACHE[url]) {
      if (PRODUCT_CACHE[url] !== 'pending') cb(PRODUCT_CACHE[url]);
      return;
    }
    PRODUCT_CACHE[url] = 'pending';
    fetch(url + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        PRODUCT_CACHE[url] = p;
        cb(p);
        upgrade(); // re-run so every fieldset annotates with cached data
      })
      .catch(function () { delete PRODUCT_CACHE[url]; });
  }

  function annotatePrices(fs, opt, inputs, product) {
    var names = (product.options || []).map(function (o) { return o && o.name ? o.name : o; });
    var idx = names.indexOf(opt);
    if (idx < 0 || !product.variants) return;

    // current selections for the *other* options, scoped to this product's form
    var root = fs.closest('product-info') || document;
    var selected = {};
    var checked = root.querySelectorAll('fieldset.product-form__input input[type="radio"]:checked');
    for (var c = 0; c < checked.length; c++) {
      var on = checked[c].getAttribute('data-option-name');
      if (on) selected[on] = checked[c].value;
    }

    var prices = [];
    for (var i = 0; i < inputs.length; i++) {
      var val = inputs[i].value;
      var variant = null;
      for (var v = 0; v < product.variants.length; v++) {
        var opts = product.variants[v].options;
        var ok = true;
        for (var j = 0; j < names.length; j++) {
          var want = j === idx ? val : selected[names[j]];
          if (want != null && opts[j] !== want) { ok = false; break; }
        }
        if (ok) { variant = product.variants[v]; break; }
      }
      prices.push(variant ? variant.price : null);
    }

    var known = prices.filter(function (p) { return p != null; });
    var varies = known.length > 1 && known.some(function (p) { return p !== known[0]; });

    for (var k = 0; k < inputs.length; k++) {
      var label = inputs[k].nextElementSibling;
      if (!label || label.tagName !== 'LABEL') continue;
      var span = label.querySelector('.ff-pill-price');
      if (!varies || prices[k] == null) {
        if (span) span.remove();
        continue;
      }
      var count = unitCount(inputs[k].value);
      var text;
      if (count && count > 1) {
        text = money(Math.round(prices[k] / count)) + ' each';
      } else if (count === 1) {
        text = money(prices[k]) + ' each';
      } else {
        text = money(prices[k]);
      }
      if (!span) {
        span = document.createElement('span');
        span.className = 'ff-pill-price';
        label.appendChild(span);
      }
      if (span.textContent !== text) span.textContent = text;
    }
  }

  function upgrade() {
    var sets = document.querySelectorAll('fieldset.product-form__input');
    var skipMap = isOtherVendor();
    for (var i = 0; i < sets.length; i++) {
      var fs = sets[i];
      var inputs = fs.querySelectorAll('input[type="radio"]');
      if (!inputs.length) continue;
      var opt = inputs[0].getAttribute('data-option-name');
      if (!opt) continue;
      var legend = fs.querySelector('legend');
      var checked = fs.querySelector('input[type="radio"]:checked');
      if (legend) {
        var mapped = skipMap ? opt : (NAME_MAP[opt] || opt);
        var t = mapped + (checked ? ' — ' + checked.value : '');
        if (legend.textContent.trim() !== t) legend.textContent = t;
      }
      if (/color/i.test(opt) && inputs.length >= 6 && !fs.querySelector('.ff-color-note')) {
        var n = document.createElement('span');
        n.className = 'ff-color-note';
        n.textContent = inputs.length + ' accent colors — made to order';
        fs.appendChild(n);
      }
      if (!/color/i.test(opt)) {
        (function (fs2, opt2, inputs2) {
          getProduct(fs2, function (p) { annotatePrices(fs2, opt2, inputs2, p); });
        })(fs, opt, inputs);
      }
    }
  }

  function watch() {
    upgrade();
    var host = document.querySelector('variant-selects, variant-radios, .product__info-container');
    if (host && 'MutationObserver' in window) {
      new MutationObserver(function () { upgrade(); }).observe(host, { childList: true, subtree: true });
    }
    document.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('.product-form__input input[type="radio"]')) {
        setTimeout(upgrade, 0);
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
})();

/* FrogFits — cart extras: "Include a Message" wording, reliable note submit,
   and a free-shipping progress bar in the drawer. THRESHOLD must match the
   "Free shipping" rate on the United States zone (orders over $120). */
(function () {
  var THRESHOLD = 12000; // cents
  var LABEL = 'Include a Message';
  var PLACEHOLDER = 'Gift note, color details, delivery instructions — anything we should know.';

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function renameNote() {
    var sum = document.querySelector('#Details-CartDrawer .summary__title');
    if (sum) {
      for (var i = 0; i < sum.childNodes.length; i++) {
        var n = sum.childNodes[i];
        if (n.nodeType === 3 && n.textContent.trim()) {
          if (n.textContent.trim() !== LABEL) n.textContent = LABEL;
          break;
        }
      }
    }
    var ta = document.getElementById('CartDrawer-Note');
    if (ta) {
      if (ta.placeholder !== PLACEHOLDER) ta.placeholder = PLACEHOLDER;
      // Post the note with the checkout submission too, so it can never be
      // lost to a race with the ajax save.
      if (ta.getAttribute('form') !== 'CartDrawer-Form') ta.setAttribute('form', 'CartDrawer-Form');
      var lbl = document.querySelector('label[for="CartDrawer-Note"]');
      if (lbl && lbl.textContent !== LABEL) lbl.textContent = LABEL;
    }
    // cart page (/cart)
    var ta2 = document.getElementById('Cart-note');
    if (ta2) {
      if (ta2.placeholder !== PLACEHOLDER) ta2.placeholder = PLACEHOLDER;
      var l2 = document.querySelector('label[for="Cart-note"]');
      if (l2 && l2.textContent.trim() !== LABEL) l2.textContent = LABEL;
    }
  }

  function freeShipBar() {
    var footer = document.querySelector('cart-drawer .drawer__footer');
    if (!footer) return;
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var bar = footer.querySelector('.ff-freeship');
        // GrytFit flooring ships from its own supplier profile and never
        // qualifies for the $120 free rate. If ANY is in the cart we can't
        // promise free shipping for the order, so hide the bar completely
        // rather than show a promise that only covers part of the order.
        var eligible = 0;
        var hasIneligible = false;
        for (var i = 0; i < c.items.length; i++) {
          var it = c.items[i];
          if (/grytfit/i.test(it.vendor || '')) {
            hasIneligible = true;
            break;
          }
          eligible += it.final_line_price != null ? it.final_line_price : it.line_price;
        }
        if (!c.item_count || hasIneligible || eligible <= 0) {
          if (bar) bar.remove();
          return;
        }
        if (!bar) {
          bar = document.createElement('div');
          bar.className = 'ff-freeship';
          bar.innerHTML =
            '<p class="ff-freeship__msg"></p>' +
            '<div class="ff-freeship__track"><div class="ff-freeship__fill"></div></div>';
          footer.insertBefore(bar, footer.firstChild);
        }
        var msg = bar.querySelector('.ff-freeship__msg');
        var fill = bar.querySelector('.ff-freeship__fill');
        var total = eligible;
        var pct = Math.min(100, Math.round((total / THRESHOLD) * 100)) + '%';
        var html;
        if (total >= THRESHOLD) {
          html = 'Free US shipping unlocked';
          bar.classList.add('is-unlocked');
        } else {
          html = 'You’re <strong>' + money(THRESHOLD - total) + '</strong> away from <strong>free US shipping</strong>';
          bar.classList.remove('is-unlocked');
        }
        if (msg.innerHTML !== html) msg.innerHTML = html;
        if (fill.style.width !== pct) fill.style.width = pct;
      })
      .catch(function () {});
  }

  function apply() {
    renameNote();
    freeShipBar();
  }

  function watch() {
    apply();
    var drawer = document.querySelector('cart-drawer');
    if (drawer && 'MutationObserver' in window) {
      var pending = false;
      new MutationObserver(function (muts) {
        var relevant = false;
        for (var i = 0; i < muts.length; i++) {
          var t = muts[i].target;
          if (!(t.closest && t.closest('.ff-freeship'))) { relevant = true; break; }
        }
        if (!relevant || pending) return;
        pending = true;
        setTimeout(function () {
          pending = false;
          apply();
        }, 80);
      }).observe(drawer, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
})();

/* FrogFits — made-to-order lead time under the buy box on product pages. */
(function () {
  var TEXT = 'Made to order — ships in 2-3 days (up to 10 during busy periods).';
  function init() {
    if (document.querySelector('.ff-leadtime')) return;
    var host = document.querySelector('.product-form__buttons');
    if (!host) return;
    // Only FrogFits-made gear is made to order in-house — skip other
    // vendors' products (e.g. GrytFit flooring ships from its supplier).
    var vend = document.querySelector('.product__info-wrapper .product__text, .product__info-container .product__text');
    if (vend && !/frogfits/i.test(vend.textContent)) return;
    var el = document.createElement('p');
    el.className = 'ff-leadtime';
    el.innerHTML =
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true" focusable="false">' +
      '<circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg><span></span>';
    el.querySelector('span').textContent = TEXT;
    host.parentNode.insertBefore(el, host.nextSibling);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
